import { NULL } from "constants/primitives";
import { SavedConsentTimestamp } from "types/consent";

import { type FunctionComponent } from "preact";
import useTCFManageConsentState from "./TCFuseManageConsentState";
import TCFUserConsentContext from "./TCFUserConsentContext";
import type {
  ITCFSelectedGatpList,
  ITCFSelectedVendorList,
  SavedTCFConsent,
} from "./types";
import WidgetConfig from "helpers/init/WidgetConfig";

const TCFUserConsentProvider: FunctionComponent<
  ITCFUserConsentProviderProps
> = ({
  children = NULL,
  prevConsent = NULL,
  prevConsentTimestamp = NULL,
  vendorsList = [],
  gatpList = [],
  tcfCountry = "",
  widgetConfig,
}) => {
  const [ctx] = useTCFManageConsentState({
    prevConsent,
    prevConsentTimestamp,
    vendorsList,
    gatpList,
    tcfCountry,
    widgetConfig,
  });

  return (
    <TCFUserConsentContext.Provider value={ctx}>
      {children}
    </TCFUserConsentContext.Provider>
  );
};

export interface ITCFUserConsentProviderProps {
  prevConsent?: SavedTCFConsent;
  prevConsentTimestamp?: SavedConsentTimestamp;
  vendorsList: ITCFSelectedVendorList;
  gatpList: ITCFSelectedGatpList;
  tcfCountry: string;
  widgetConfig: WidgetConfig;
}

export default TCFUserConsentProvider;
